export const bundleCarouselStyles = {
    '.bundle-child-carousel': {
        '.product-block': {
            backgroundColor: '#fff',
            borderRadius: 'lg',
            padding: '8px 20px 20px'
        },
        '.slick-slider': {
            position: 'relative'
        },
        '.slick-track': {
            display: 'flex',
            paddingRight: {base: '0', md: '32'},
            pt: {base: '0', md: '2px'},
            pl: {base: '0', md: '2px'}
        },
        '.slick-arrow.slick-disabled': {
            display: 'none'
        },
        '.slick-arrow': {
            top: '0',
            position: 'absolute',
            height: '100%',
            width: {base: '12', md: '32'},
            background: {
                base: 'unset',
                sm: 'linear-gradient(90deg, rgba(248, 246, 243, 0.00) 0%, rgba(248, 246, 243, 0.53) 28.39%, #F8F6F3 94.62%)'
            }
        },
        '.slick-prev': {
            left: '0',
            zIndex: '1',
            transform: 'rotate(180deg)'
        },
        '.slick-next': {
            right: '0'
        },
        '.slick-arrow svg': {
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: '50%',
            right: {base: '0', md: '4'}
        },
        '.slick-slide': {
            marginRight: {base: '0', sm: '4', xl: '8'}
        },
        '.product-promotions, .preandbackOrderMessage, .product-prices, .pr-custom-ratings-plp': {
            display: 'none'
        },
        '.addtocartbutton': {
            borderRadius: '50px',
            py: '3'
        }
    }
}
